<template>
  <div>
    <div id="cont" class="container">
      <b-modal id="input_age">
        <strong>输入您的年龄</strong>
        <b-input v-model="assistImg"/>
      </b-modal>
      <div class="row">
        <div class="col-12">
          <b-nav
              id="nav">
            <a href="#/">
              <b-img
                  :src="logoImg"
                  alt="Emu"
                  id="logo"></b-img>
            </a>
            <a href="#/assist">
              <b-img
                  :src="assistImg"
                  alt="Assist"
                  id="assist"
              ></b-img>
            </a>
            <a href="#/assist">
              <h4 id="assist_label">智能助手</h4>
            </a>
            <div class="ml-auto" id="breadcrumb">
              <small class="bc-divider">当前位置：</small>
              <a class="bc-active">个人中心</a>
            </div>
          </b-nav>
        </div>
      </div>
      <div class="row">
        <div id="sidebar" class="col-md-4">
          <side-bar></side-bar>
        </div>
        <div id="content" class="col-md-8">
          <h4 id="title">欢迎您，</h4>
          <div id="infos">
            <p>真实姓名</p>
            <strong>{{ data.name }}</strong>
            <p>性别</p>
            <strong>{{ data.gender }}</strong>
            <p>出生日期</p>
            <strong>{{ data.birthday }}</strong>
            <p>现居住地</p>
            <strong>{{ data.address }}</strong>
            <p>监护人</p>
            <strong>{{ data.contact }}</strong>
            <p>工作单位</p>
            <strong>Emu易苗</strong>
            <p>固定电话</p>
            <strong>{{ data.contact_phone }}</strong>
            <p>移动电话</p>
            <strong>{{ data.phone }}</strong>
            <p>邮箱</p>
            <strong>{{ data.email }}</strong>
            <p>过敏史</p>
            <strong>{{ data.allergen }}</strong>
          </div>
          <b-button pill id="change" variant="info">修改个人资料</b-button>
          <br>
          <b-button pill id="logout" variant="info">登出</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from "../common";
import SideBar from "@/components/SideBar";

export default {
  name: "Personal",
  components: {SideBar},
  data() {
    return {
      logoImg: common.logoImgSrc,
      assistImg: common.assistImgSrc,
      data: {
        pid: 0,
        name: "",
        birthday: "",
        gender: "",
        allergen: "",
        medical_history: "",
        province: "",
        city: "",
        district: "",
        contact: "",
        contact_phone: "",
        phone: "",
        email: "",
        address: ""
      }
    }
  },
  mounted() {
    common.assureLogin(this);
    this.$bvModal.show("input_age");
    this.axios.post(common.apiBase + common.apiService.getPatient, {
      'token': localStorage.getItem("loginToken")
    }).then((res) => {
      this.data = res.data.data;
    }).catch((err) => {
      console.log(err);
    });
    document.querySelector("#logout").onclick = () => {
      this.axios.post(common.apiBase + common.apiService.logout, {
        'token': localStorage.getItem("loginToken")
      }).then(() => {
        localStorage.removeItem('loginToken');
        localStorage.removeItem('loginName');
        this.$router.push("/login");
      }).catch((err) => {
        console.log(err);
      });
    }
    document.querySelector("#change").onclick = () => {
      this.$router.push("/update");
    }
    document.querySelector("#title").innerHTML += localStorage.getItem('loginName');
  }
}
</script>

<style>

body {
  background: #f5f5f5 !important;
}
</style>

<style scoped src="../main.css"/>

<style scoped>
#content {
  padding-left: 10%;
  padding-top: 3vh;
}

#title {
  font-weight: bold;
}

#infos {
  margin-top: 40px;
  display: grid;
  grid-template-columns: 100px 4fr;
  grid-template-rows: repeat(10, 50px);
  width: 50%;
}

#infos p {
  color: grey;
}

#change, #logout {
  margin-left: 50%;
  transform: translateX(-50%);
  margin-bottom: 20px;
  padding-left: 30px;
  padding-right: 30px;
}
</style>